module.exports = __webpack_public_path__ + "static/media/metodo_1.18b713a0.png";